import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from '../../LanguageContext';
import styles from './ProjectsGallery.module.css';

// ========================================
// בית פרטי בשילת - 31 תמונות
// ========================================
import shilat1 from '../../images/בית פרטי בשילת 1.webp';
import shilat2 from '../../images/בית פרטי בשילת 2.webp';
import shilat3 from '../../images/בית פרטי בשילת 3.webp';
import shilat4 from '../../images/בית פרטי בשילת 4.webp';
import shilat5 from '../../images/בית פרטי בשילת 5.webp';
import shilat6 from '../../images/בית פרטי בשילת 6.webp';
import shilat7 from '../../images/בית פרטי בשילת 7.webp';
import shilat8 from '../../images/בית פרטי בשילת 8.webp';
import shilat9 from '../../images/בית פרטי בשילת 9.webp';
import shilat10 from '../../images/בית פרטי בשילת 10.webp';
import shilat11 from '../../images/בית פרטי בשילת 11.webp';
import shilat12 from '../../images/בית פרטי בשילת 12.webp';
import shilat13 from '../../images/בית פרטי בשילת 13.webp';
import shilat14 from '../../images/בית פרטי בשילת 14.webp';
import shilat15 from '../../images/בית פרטי בשילת 15.webp';
import shilat16 from '../../images/בית פרטי בשילת 16.webp';
import shilat17 from '../../images/בית פרטי בשילת 17.webp';
import shilat18 from '../../images/בית פרטי בשילת 18.webp';
import shilat19 from '../../images/בית פרטי בשילת 19.webp';
import shilat20 from '../../images/בית פרטי בשילת 20.webp';
import shilat21 from '../../images/בית פרטי בשילת 21.webp';
import shilat22 from '../../images/בית פרטי בשילת 22.webp';
import shilat23 from '../../images/בית פרטי בשילת 23.webp';
import shilat24 from '../../images/בית פרטי בשילת 24.webp';
import shilat25 from '../../images/בית פרטי בשילת 25.webp';
import shilat26 from '../../images/בית פרטי בשילת 26.webp';
import shilat27 from '../../images/בית פרטי בשילת 27.webp';
import shilat28 from '../../images/בית פרטי בשילת 28.webp';
import shilat29 from '../../images/בית פרטי בשילת 29.webp';
import shilat30 from '../../images/בית פרטי בשילת 30.webp';
import shilat31 from '../../images/בית פרטי בשילת 31.webp';

// ========================================
// יוקרה במגדל - 32 תמונות
// ========================================
import migdal1 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 1.webp';
import migdal2 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 2.webp';
import migdal3 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 3.webp';
import migdal4 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 4.webp';
import migdal5 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 5.webp';
import migdal6 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 6.webp';
import migdal7 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 7.webp';
import migdal8 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 8.webp';
import migdal9 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 9.webp';
import migdal10 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 10.webp';
import migdal11 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 11.webp';
import migdal12 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 12.webp';
import migdal13 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 13.webp';
import migdal14 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 14.webp';
import migdal15 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 15.webp';
import migdal16 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 16.webp';
import migdal17 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 17.webp';
import migdal18 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 18.webp';
import migdal19 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 19.webp';
import migdal20 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 20.webp';
import migdal21 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 21.webp';
import migdal22 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 22.webp';
import migdal23 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 23.webp';
import migdal24 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 24.webp';
import migdal25 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 25.webp';
import migdal26 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 26.webp';
import migdal27 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 27.webp';
import migdal28 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 28.webp';
import migdal29 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 29.webp';
import migdal30 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 30.webp';
import migdal31 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 31.webp';
import migdal32 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 32.webp';

// ========================================
// בית פרטי ברמת חן - בית הפליסה - 48 תמונות
// ========================================
import ramatChen1 from '../../images/בית פרטי ברמת חן -בית הפליסה 1.webp';
import ramatChen2 from '../../images/בית פרטי ברמת חן -בית הפליסה 2.webp';
import ramatChen3 from '../../images/בית פרטי ברמת חן -בית הפליסה 3.webp';
import ramatChen4 from '../../images/בית פרטי ברמת חן -בית הפליסה 4.webp';
import ramatChen5 from '../../images/בית פרטי ברמת חן -בית הפליסה 5.webp';
import ramatChen6 from '../../images/בית פרטי ברמת חן -בית הפליסה 6.webp';
import ramatChen7 from '../../images/בית פרטי ברמת חן -בית הפליסה 7.webp';
import ramatChen8 from '../../images/בית פרטי ברמת חן -בית הפליסה 8.webp';
import ramatChen9 from '../../images/בית פרטי ברמת חן -בית הפליסה 9.webp';
import ramatChen10 from '../../images/בית פרטי ברמת חן -בית הפליסה 10.webp';
import ramatChen11 from '../../images/בית פרטי ברמת חן -בית הפליסה 11.webp';
import ramatChen12 from '../../images/בית פרטי ברמת חן -בית הפליסה 12.webp';
import ramatChen13 from '../../images/בית פרטי ברמת חן -בית הפליסה 13.webp';
import ramatChen14 from '../../images/בית פרטי ברמת חן -בית הפליסה 14.webp';
import ramatChen15 from '../../images/בית פרטי ברמת חן -בית הפליסה 15.webp';
import ramatChen16 from '../../images/בית פרטי ברמת חן -בית הפליסה 16.webp';
import ramatChen17 from '../../images/בית פרטי ברמת חן -בית הפליסה 17.webp';
import ramatChen18 from '../../images/בית פרטי ברמת חן -בית הפליסה 18.webp';
import ramatChen19 from '../../images/בית פרטי ברמת חן -בית הפליסה 19.webp';
import ramatChen20 from '../../images/בית פרטי ברמת חן -בית הפליסה 20.webp';
import ramatChen21 from '../../images/בית פרטי ברמת חן -בית הפליסה 21.webp';
import ramatChen22 from '../../images/בית פרטי ברמת חן -בית הפליסה 22.webp';
import ramatChen23 from '../../images/בית פרטי ברמת חן -בית הפליסה 23.webp';
import ramatChen24 from '../../images/בית פרטי ברמת חן -בית הפליסה 24.webp';
import ramatChen25 from '../../images/בית פרטי ברמת חן -בית הפליסה 25.webp';
import ramatChen26 from '../../images/בית פרטי ברמת חן -בית הפליסה 26.webp';
import ramatChen27 from '../../images/בית פרטי ברמת חן -בית הפליסה 27.webp';
import ramatChen28 from '../../images/בית פרטי ברמת חן -בית הפליסה 28.webp';
import ramatChen29 from '../../images/בית פרטי ברמת חן -בית הפליסה 29.webp';
import ramatChen30 from '../../images/בית פרטי ברמת חן -בית הפליסה 30.webp';
import ramatChen31 from '../../images/בית פרטי ברמת חן -בית הפליסה 31.webp';
import ramatChen32 from '../../images/בית פרטי ברמת חן -בית הפליסה 32.webp';
import ramatChen33 from '../../images/בית פרטי ברמת חן -בית הפליסה 33.webp';
import ramatChen34 from '../../images/בית פרטי ברמת חן -בית הפליסה 34.webp';
import ramatChen35 from '../../images/בית פרטי ברמת חן -בית הפליסה 35.webp';
import ramatChen36 from '../../images/בית פרטי ברמת חן -בית הפליסה 36.webp';
import ramatChen37 from '../../images/בית פרטי ברמת חן -בית הפליסה 37.webp';
import ramatChen38 from '../../images/בית פרטי ברמת חן -בית הפליסה 38.webp';
import ramatChen39 from '../../images/בית פרטי ברמת חן -בית הפליסה 39.webp';
import ramatChen40 from '../../images/בית פרטי ברמת חן -בית הפליסה 40.webp';
import ramatChen41 from '../../images/בית פרטי ברמת חן -בית הפליסה 41.webp';
import ramatChen42 from '../../images/בית פרטי ברמת חן -בית הפליסה 42.webp';
import ramatChen43 from '../../images/בית פרטי ברמת חן -בית הפליסה 43.webp';
import ramatChen44 from '../../images/בית פרטי ברמת חן -בית הפליסה 44.webp';
import ramatChen45 from '../../images/בית פרטי ברמת חן -בית הפליסה 45.webp';
import ramatChen46 from '../../images/בית פרטי ברמת חן -בית הפליסה 46.webp';
import ramatChen47 from '../../images/בית פרטי ברמת חן -בית הפליסה 47.webp';
import ramatChen48 from '../../images/בית פרטי ברמת חן -בית הפליסה 48.webp';

// ========================================
// דירה תל אביבית בשחקים - 21 תמונות
// ========================================
import tlvSky1 from '../../images/דירה תל אביבית בשחקים 1.webp';
import tlvSky2 from '../../images/דירה תל אביבית בשחקים 2.webp';
import tlvSky3 from '../../images/דירה תל אביבית בשחקים 3.webp';
import tlvSky4 from '../../images/דירה תל אביבית בשחקים 4.webp';
import tlvSky5 from '../../images/דירה תל אביבית בשחקים 5.webp';
import tlvSky6 from '../../images/דירה תל אביבית בשחקים 6.webp';
import tlvSky7 from '../../images/דירה תל אביבית בשחקים 7.webp';
import tlvSky8 from '../../images/דירה תל אביבית בשחקים 8.webp';
import tlvSky9 from '../../images/דירה תל אביבית בשחקים 9.webp';
import tlvSky10 from '../../images/דירה תל אביבית בשחקים 10.webp';
import tlvSky11 from '../../images/דירה תל אביבית בשחקים 11.webp';
import tlvSky12 from '../../images/דירה תל אביבית בשחקים 12.webp';
import tlvSky13 from '../../images/דירה תל אביבית בשחקים 13.webp';
import tlvSky14 from '../../images/דירה תל אביבית בשחקים 14.webp';
import tlvSky15 from '../../images/דירה תל אביבית בשחקים 15.webp';
import tlvSky16 from '../../images/דירה תל אביבית בשחקים 16.webp';
import tlvSky17 from '../../images/דירה תל אביבית בשחקים 17.webp';
import tlvSky18 from '../../images/דירה תל אביבית בשחקים 18.webp';
import tlvSky19 from '../../images/דירה תל אביבית בשחקים 19.webp';
import tlvSky20 from '../../images/דירה תל אביבית בשחקים 20.webp';
import tlvSky21 from '../../images/דירה תל אביבית בשחקים 21.webp';

// ========================================
// תמונות נוספות
// ========================================
import image1 from "../../images/בית בניחוח ספרדי 11.webp";
import image2 from "../../images/פנטהאוז תל אביבי - הגוש הגדול 8.webp";
import image3 from "../../images/בית מודרני ואלגנטי בכפר בילו 37.webp";
import image4 from "../../images/בית פרטי כפר אורנים 4.webp";
import image5 from "../../images/דירת קבלן משודרגת 10.webp";

gsap.registerPlugin(ScrollTrigger);

// ========================================
// מערכי תמונות
// ========================================
const shilatImages = [
  shilat1, shilat2, shilat3, shilat4, shilat5, shilat6, shilat7, shilat8, shilat9, shilat10,
  shilat11, shilat12, shilat13, shilat14, shilat15, shilat16, shilat17, shilat18, shilat19, shilat20,
  shilat21, shilat22, shilat23, shilat24, shilat25, shilat26, shilat27, shilat28, shilat29, shilat30,
  shilat31
];

const migdalImages = [
  migdal1, migdal2, migdal3, migdal4, migdal5, migdal6, migdal7, migdal8, migdal9, migdal10,
  migdal11, migdal12, migdal13, migdal14, migdal15, migdal16, migdal17, migdal18, migdal19, migdal20,
  migdal21, migdal22, migdal23, migdal24, migdal25, migdal26, migdal27, migdal28, migdal29, migdal30,
  migdal31, migdal32
];

const ramatChenImages = [
  ramatChen1, ramatChen2, ramatChen3, ramatChen4, ramatChen5, ramatChen6, ramatChen7, ramatChen8, ramatChen9, ramatChen10,
  ramatChen11, ramatChen12, ramatChen13, ramatChen14, ramatChen15, ramatChen16, ramatChen17, ramatChen18, ramatChen19, ramatChen20,
  ramatChen21, ramatChen22, ramatChen23, ramatChen24, ramatChen25, ramatChen26, ramatChen27, ramatChen28, ramatChen29, ramatChen30,
  ramatChen31, ramatChen32, ramatChen33, ramatChen34, ramatChen35, ramatChen36, ramatChen37, ramatChen38, ramatChen39, ramatChen40,
  ramatChen41, ramatChen42, ramatChen43, ramatChen44, ramatChen45, ramatChen46, ramatChen47, ramatChen48
];

const tlvSkyImages = [
  tlvSky1, tlvSky2, tlvSky3, tlvSky4, tlvSky5, tlvSky6, tlvSky7, tlvSky8, tlvSky9, tlvSky10,
  tlvSky11, tlvSky12, tlvSky13, tlvSky14, tlvSky15, tlvSky16, tlvSky17, tlvSky18, tlvSky19, tlvSky20,
  tlvSky21
];

// ========================================
// פרויקטים
// ========================================
const projects = [
  {
    id: 1,
    title: 'בית פרטי בשילת',
    subtitle: 'עיצוב פנים מקיף',
    year: '2024',
    area: '380 מ"ר',
    isFlagship: true,
    featuredIn: 'Forbes',
    thumbnail: shilatImages[4],
    mainImage: shilatImages[4],
    description: 'בית משפחתי מרווח במושב שילת, המשלב עיצוב כפרי-מודרני עם חומרים טבעיים. התכנון התמקד ביצירת זרימה טבעית בין החללים הפנימיים לחצר הירוקה, תוך שמירה על אווירה חמה ומזמינה לכל המשפחה.',
    gallery: shilatImages.slice(1),
  },
  {
    id: 2,
    title: 'יוקרה במגדל',
    subtitle: 'דירת יוקרה אורבנית',
    year: '2024',
    area: '220 מ"ר',
    isFlagship: true,
    thumbnail: migdalImages[10],
    mainImage: migdalImages[0],
    description: 'דירת יוקרה במגדל מגורים יוקרתי בתל אביב. העיצוב משלב קווים נקיים ומודרניים עם נגיעות של חומרים עשירים כמו שיש, עץ אלון ופליז. הנוף הפנורמי לעיר היווה השראה מרכזית בתכנון החללים.',
    gallery: migdalImages.slice(1),
  },
  {
    id: 3,
    title: 'בית הפליסה',
    subtitle: 'בית פרטי ברמת חן',
    year: '2023',
    area: '450 מ"ר',
    isFlagship: true,
    thumbnail: ramatChenImages[3],
    mainImage: ramatChenImages[3],
    description: 'בית פרטי מרשים ברמת חן, המכונה "בית הפליסה" בזכות עבודת הפליסה הייחודית שמשתלבת לאורך כל הבית. שילוב של אדריכלות קלאסית עם עיצוב פנים עכשווי, תוך דגש על פרטים מדויקים ואיכות ביצוע גבוהה.',
    gallery: ramatChenImages.slice(1),
  },
  {
    id: 4,
    title: 'דירה תל אביבית בשחקים',
    subtitle: 'פנטהאוז עירוני',
    year: '2024',
    area: '180 מ"ר',
    isFlagship: true,
    thumbnail: tlvSkyImages[0],
    mainImage: tlvSkyImages[0],
    description: 'דירת יוקרה בקומות הגבוהות של תל אביב, עם נוף פנורמי עוצר נשימה. העיצוב משלב אלגנטיות עירונית עם נוחות ביתית, תוך ניצול מקסימלי של האור הטבעי והנוף. חומרים איכותיים ופרטים מדויקים יוצרים חלל מגורים מרשים ומזמין.',
    gallery: tlvSkyImages.slice(1),
  },
];

const ProjectsGallery = () => {
  const { t, isEnglish } = useTranslation();
  const sectionRef = useRef(null);
  const modalRef = useRef(null);
  const gridRef = useRef(null);
  const cardsRef = useRef([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Scroll Reveal Animation for project cards
  useEffect(() => {
    const ctx = gsap.context(() => {
      // Set initial state for all cards
      cardsRef.current.forEach((card) => {
        if (card) {
          gsap.set(card, {
            opacity: 0,
            y: 60,
            scale: 0.95,
          });
        }
      });

      // Animate each card when it comes into view
      cardsRef.current.forEach((card, index) => {
        if (card) {
          gsap.to(card, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              end: 'top 60%',
              toggleActions: 'play none none none',
            },
            delay: (index % 4) * 0.1,
          });
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  // Project handlers
  const openProject = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    document.body.style.overflow = 'hidden';
  };

  const closeProject = () => {
    document.body.style.overflow = '';
    setSelectedProject(null);
    setIsGalleryOpen(false);
  };

  // Scroll reset when modal opens
  useEffect(() => {
    if (selectedProject && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [selectedProject]);

  const openGallery = (index = 0) => {
    setCurrentImageIndex(index);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
  };

  const nextImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prev) =>
        prev === selectedProject.gallery.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedProject) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? selectedProject.gallery.length - 1 : prev - 1
      );
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isGalleryOpen) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.key === 'ArrowRight' ? prevImage() : nextImage();
        } else if (e.key === 'Escape') {
          closeGallery();
        }
      } else if (selectedProject && e.key === 'Escape') {
        closeProject();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isGalleryOpen, selectedProject]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // Prevent scroll on background when modal is open
  useEffect(() => {
    if (selectedProject) {
      const scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      document.body.setAttribute('data-scroll-position', scrollY.toString());
    } else {
      const scrollPosition = document.body.getAttribute('data-scroll-position');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      document.body.removeAttribute('data-scroll-position');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition, 10));
      }
    }
  }, [selectedProject]);

  // Get translated project data
  const getProjectData = (project, index) => {
    const tProject = t.projectsGallery.projects[index];
    if (!tProject) return project;
    return {
      ...project,
      title: tProject.title,
      subtitle: tProject.subtitle,
      area: tProject.area,
      description: tProject.description,
    };
  };

  // Project Card Component
  const ProjectCard = ({ project, index }) => {
    const translatedProject = getProjectData(project, index);
    return (
      <article
        className={`${styles.projectCard} ${project.isFlagship ? styles.flagshipCard : ''}`}
        onClick={() => openProject({ ...project, ...translatedProject })}
        ref={(el) => (cardsRef.current[index] = el)}
      >
        {/* Flagship Ribbon */}
        {project.isFlagship && (
          <div className={styles.ribbonWrapper}>
            <div className={styles.ribbon}>
              <span>{t.projectsGallery.flagshipProject}</span>
            </div>
          </div>
        )}

        {/* Forbes Badge */}
        {project.featuredIn === 'Forbes' && (
          <div className={styles.forbesBadge}>
            <div className={styles.forbesBadgeInner}>
              <span className={styles.forbesText}>FORBES</span>
              <span className={styles.forbesSubtext}>As Featured In</span>
            </div>
          </div>
        )}

        {/* Image Container */}
        <div className={styles.imageContainer}>
          <img
            src={project.thumbnail}
            alt={project.title}
            className={styles.projectImage}
            loading="lazy"
            decoding="async"
          />
          
          {/* Overlay */}
          <div className={styles.cardOverlay}>
            <div className={styles.overlayContent}>
              <span className={styles.viewProject}>{t.projectsGallery.viewProject}</span>
              <div className={styles.arrowIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M7 17L17 7M17 7H7M17 7V17"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Card Content */}
        <div className={styles.cardContent}>
          <div className={styles.cardMeta}>
            <span className={styles.year}>{project.year}</span>
            <span className={styles.divider}></span>
            <span className={styles.area}>{project.area}</span>
            {project.featuredIn && (
              <>
                <span className={styles.divider}></span>
              </>
            )}
          </div>
          <h3 className={styles.cardTitle}>{translatedProject.title}</h3>
          <p className={styles.cardSubtitle}>{translatedProject.subtitle}</p>
        </div>
      </article>
    );
  };

  return (
    <section className={styles.projectsSection} ref={sectionRef}>
      {/* Decorative Elements */}
      <div className={styles.bgDecoration}>
        <div className={styles.gridPattern}></div>
        <div className={styles.cornerAccent}></div>
        <div className={styles.cornerAccentBottom}></div>
      </div>

      {/* Title Section - ללא קישוט */}
      <header className={styles.titleSection}>
        <h2 className={styles.sectionTitle}>{t.projectsGallery.title}</h2>
        <p className={styles.sectionSubtitle}>{t.projectsGallery.subtitle}</p>
      </header>

      {/* Projects Grid */}
      <div className={styles.projectsGrid} ref={gridRef}>
        {projects.map((project, index) => (
          <ProjectCard key={project.id} project={project} index={index} />
        ))}
      </div>

      {/* WhatsApp Consultation Button */}
      <div className={styles.ctaContainer}>
        <a
          href="https://wa.me/972544998929?text=%D7%94%D7%99%D7%99%20%D7%A0%D7%A8%D7%A7%D7%99%D7%A1%2C%20%D7%94%D7%92%D7%A2%D7%AA%D7%99%20%D7%9E%D7%94%D7%93%D7%A3%20%D7%A9%D7%9C%D7%9A%20%D7%95%D7%90%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A9%D7%9E%D7%95%D7%A2%20%D7%A2%D7%95%D7%93"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}
        >
          <span>{t.projectsGallery.ctaText}</span>
          <svg className={styles.ctaArrow} viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className={styles.modalBackdrop} ref={modalRef}>
          <div className={styles.modal}>
            {/* Close Button */}
            <button className={styles.closeBtn} onClick={closeProject} aria-label="סגור">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>

            {/* Modal Hero */}
            <div className={styles.modalHero}>
              <img
                src={selectedProject.mainImage}
                alt={selectedProject.title}
                className={styles.heroImage}
                loading="lazy"
                decoding="async"
              />
              <div className={styles.heroOverlay}></div>
              
              {/* Flagship Ribbon in Modal */}
              {selectedProject.isFlagship && (
                <div className={styles.modalRibbonWrapper}>
                  <div className={styles.modalRibbon}>
                    <span>{t.projectsGallery.flagshipProject}</span>
                  </div>
                </div>
              )}

              {/* Forbes Badge in Modal */}
              {selectedProject.featuredIn === 'Forbes' && (
                <div className={styles.modalForbesBadge}>
                  <div className={styles.modalForbesContent}>
                    <span className={styles.modalForbesLabel}>As Featured In</span>
                    <span className={styles.modalForbesLogo}>FORBES</span>
                  </div>
                </div>
              )}
            </div>

            {/* Modal Content */}
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <div className={styles.modalMeta}>
                  <span>{selectedProject.year}</span>
                  <span className={styles.metaDot}></span>
                  <span>{selectedProject.area}</span>
                  <span className={styles.metaDot}></span>
                  <span>{selectedProject.gallery.length} {t.projectsGallery.photos}</span>
                  {selectedProject.featuredIn && (
                    <>
                      <span className={styles.metaDot}></span>
                      <span className={styles.modalFeaturedTag}>
                        <svg className={styles.starIconSmall} viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        {t.projectsGallery.featuredIn}{selectedProject.featuredIn}
                      </span>
                    </>
                  )}
                </div>
                <h2 className={styles.modalTitle}>{selectedProject.title}</h2>
                <p className={styles.modalSubtitle}>{selectedProject.subtitle}</p>
              </div>

              <p className={styles.modalDescription}>{selectedProject.description}</p>

              {/* Gallery Grid */}
              <div className={styles.gallerySection}>
                <h4 className={styles.gallerySectionTitle}>
                  <span className={styles.galleryTitleLine}></span>
                  {t.projectsGallery.photoGallery}
                  <span className={styles.galleryTitleLine}></span>
                </h4>
                <div className={styles.modalGallery}>
                  {selectedProject.gallery.map((img, idx) => (
                    <div
                      key={idx}
                      className={styles.galleryThumb}
                      onClick={() => openGallery(idx)}
                    >
                      <img src={img} alt={`${selectedProject.title} - תמונה ${idx + 1}`} loading="lazy" decoding="async" />
                      <div className={styles.thumbOverlay}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7"/>
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Full Gallery Lightbox */}
      {isGalleryOpen && selectedProject && (
        <div className={styles.galleryOverlay}>
          {/* Close Button */}
          <button className={styles.galleryCloseBtn} onClick={closeGallery} aria-label="סגור גלריה">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>

          {/* Main Image Viewer */}
          <div className={styles.galleryViewer}>
            <img
              src={selectedProject.gallery[currentImageIndex]}
              alt={`${selectedProject.title} - עיצוב פנים - תמונה ${currentImageIndex + 1}`}
              className={styles.galleryMainImage}
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Navigation Arrows */}
          <button className={`${styles.galleryNavBtn} ${styles.navPrev}`} onClick={prevImage} aria-label="תמונה קודמת">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
          <button className={`${styles.galleryNavBtn} ${styles.navNext}`} onClick={nextImage} aria-label="תמונה הבאה">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          {/* Progress Bar */}
          <div className={styles.galleryProgress}>
            <div className={styles.progressTrack}>
              {selectedProject.gallery.map((_, idx) => (
                <div
                  key={idx}
                  className={`${styles.progressDot} ${idx === currentImageIndex ? styles.progressActive : ''}`}
                  onClick={() => setCurrentImageIndex(idx)}
                />
              ))}
            </div>
            <span className={styles.progressCounter}>
              {currentImageIndex + 1} / {selectedProject.gallery.length}
            </span>
          </div>

          {/* Thumbnails Strip */}
          <div className={styles.galleryThumbs}>
            {selectedProject.gallery.map((img, idx) => (
              <div
                key={idx}
                className={`${styles.thumbItem} ${idx === currentImageIndex ? styles.thumbActive : ''}`}
                onClick={() => setCurrentImageIndex(idx)}
              >
                <img src={img} alt={`${selectedProject.title} - תמונה ${idx + 1}`} loading="lazy" decoding="async" />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ProjectsGallery;